var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OrderCouponGift,{attrs:{"show":_setup.modal.visible.value,"data":_setup.innerData},on:{"close":_setup.onClear,"receive":_setup.onReceive,"exchange":_setup.onExchange}})
}
var staticRenderFns = []

export { render, staticRenderFns }